import { BaseService } from "../../core/baseService";
import { ApiResult } from "../../core/types";

export interface SupportedLanguage {
  code: string;
  name: string;
}

export interface LanguagesServiceInterface {
  getSupportedLanguages(): Promise<ApiResult<SupportedLanguage[]>>;
}

export class LanguagesService
  extends BaseService
  implements LanguagesServiceInterface
{
  async getSupportedLanguages(): Promise<ApiResult<SupportedLanguage[]>> {
    return this.handleRequest<SupportedLanguage[]>(
      this.client.get("/api/admin/languages"),
    );
  }
}
